<div class="bplayer-error-tip">
    <div class="bplayer-error-icon"></div>
    <p class="bplayer-error-text">{{ text }}</p>
</div>